import { useSyncExternalStore } from 'react';

// El asistente vive en Layout, fuera del formulario. Compartimos únicamente los
// IDs de requisitos pendientes: nunca los valores sin guardar de la factura.
let snapshot = null;
const listeners = new Set();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => snapshot;

export function publishInvoiceFormContext({ missing = [], readOnly = false }) {
  const ids = [...new Set(missing)];
  if (snapshot?.readOnly === readOnly && snapshot?.missing.join('|') === ids.join('|')) return;
  snapshot = { missing: ids, readOnly };
  listeners.forEach((listener) => listener());
}

export function clearInvoiceFormContext() {
  if (snapshot === null) return;
  snapshot = null;
  listeners.forEach((listener) => listener());
}

export function useInvoiceFormContext() {
  return useSyncExternalStore(subscribe, getSnapshot, () => null);
}
